// src/plugins/viewport.js
export const Viewport = {
  install(Vue) {
    Vue.prototype.$viewport = {
      getCurrentBreakpoint() {
        const width = window.innerWidth;
        if (width < 576) return 'xs';
        if (width < 768) return 'sm';
        if (width < 992) return 'md';
        if (width < 1200) return 'lg';
        return 'xl';
      },
      isMobile() {
        return window.innerWidth < 768;
      },
    };
  },
};
